module.exports = __webpack_public_path__ + "img/yc-line-1-2.svg";